"use client";

import { useActionState } from "react";
import { Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  submitWaitlistEntry,
  type WaitlistFormState,
} from "@/lib/actions/waitlist";

const initial: WaitlistFormState = {};

export function WaitlistForm() {
  const [state, formAction, pending] = useActionState(
    submitWaitlistEntry,
    initial,
  );

  if (state.success) {
    return (
      <p className="text-sm text-muted-foreground" role="status">
        Thanks — you&apos;re on the list. We&apos;ll be in touch when
        there&apos;s a spot.
      </p>
    );
  }

  return (
    <form action={formAction} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium">
          Email
        </Label>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          placeholder="you@example.com"
          className="touch-target text-base"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="reason" className="text-sm font-medium">
          About you (optional)
        </Label>
        <Textarea
          id="reason"
          name="reason"
          placeholder="A little about your beekeeping — colonies, years, anything you want us to know."
          rows={3}
          maxLength={500}
          className="resize-none"
        />
      </div>

      {state.error && (
        <p className="text-xs text-destructive" role="alert">
          {state.error}
        </p>
      )}

      <button
        type="submit"
        disabled={pending}
        className="flex items-center justify-center gap-2 w-full rounded-full bg-honey-deep text-cream-50 font-semibold px-5 py-3 transition-colors hover:bg-honey active:bg-honey-deep disabled:opacity-60 disabled:cursor-not-allowed touch-target text-base"
      >
        <Send className="h-4 w-4" strokeWidth={2} />
        {pending ? "Sending…" : "Join waitlist"}
      </button>
    </form>
  );
}
